import React, { createContext, useState, useContext, ReactNode } from 'react';

type SearchTabContextProps = {
	children: ReactNode;
};

export type SelectedListItem =
	| 'AI Search'
	| 'Search'
	| 'Location'
	| 'Contact Status'
	| 'Contact Info'
	| 'Business Info'
	| '';

export type SearchFilter = { type: 0 | 1; value: string; index: number };

type SearchTabContextValue = {
	selectedListItem: SelectedListItem;
	setSelectedListItem: (x: SelectedListItem) => void;
	selectedLocation: string;
	setSelectedLocation: (x: string) => void;
	yelpReviewsFilterMin: number | string;
	setYelpReviewsFilterMin: (x: number | string) => void;
	yelpReviewsFilterMax: number | string;
	setYelpReviewsFilterMax: (x: number | string) => void;
};

const SearchTabContext = createContext<SearchTabContextValue>(undefined);

// This context was created so that all the different list item dropdowns can keep track of which list item is currently
// selected/opened so we can apply the appropriate css to them
export const SearchTabContextProvider = ({
	children
}: SearchTabContextProps) => {
	const [selectedListItem, setSelectedListItem] =
		useState<SelectedListItem>('');
	const [selectedLocation, setSelectedLocation] = useState<string>('');
	const [yelpReviewsFilterMin, setYelpReviewsFilterMin] = useState<
		number | string
	>('');
	const [yelpReviewsFilterMax, setYelpReviewsFilterMax] = useState<
		number | string
	>('');

	return (
		<SearchTabContext.Provider
			value={{
				selectedListItem,
				setSelectedListItem,
				selectedLocation,
				setSelectedLocation,
				yelpReviewsFilterMin,
				setYelpReviewsFilterMin,
				yelpReviewsFilterMax,
				setYelpReviewsFilterMax
			}}
		>
			{children}
		</SearchTabContext.Provider>
	);
};

export const useSearchTabContext = () => {
	return useContext(SearchTabContext);
};
